import React from "react";
import { Select } from "antd";

import { OPTION_LABELS } from "../../../config/lang";
import { translate } from "../../../util/util";
import fieldIcon from "./fieldIcons";

export default function SelectField({ field, value, onChange, lang }) {
  // Localize option display labels (keyed by value); fall back to the raw label.
  const options = (field.options || []).map(o => ({ value: o.value, label: translate(OPTION_LABELS, String(o.value), lang) || o.label }));
  return (
    <Select
      prefix={fieldIcon(field)}
      options={options}
      value={value ?? undefined}
      allowClear={!field.required}
      onChange={next => onChange(field.name, next ?? null)}
    />
  );
}
